import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { DialogModule } from '../dialog/dialog.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { PdfRerenderDialogComponent } from './components/pdf-rerender-dialog/pdf-rerender-dialog.component';
import { RendererComponent } from './renderer.component';
import { RendererService } from './renderer.service';

const components = [RendererComponent, PdfRerenderDialogComponent];

@NgModule({
  imports: [CommonModule, SharedModule, FormMasterModule, DialogModule],
  declarations: [...components],
  exports: [...components],
})
export class RendererModule {
  static forRoot(): ModuleWithProviders<RendererModule> {
    return {
      ngModule: RendererModule,
      providers: [RendererService],
    };
  }
}
